import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {
  getSelectedOrderFromOrdersSearch,
  getSimplrAccountIdOfSelectedTicket,
} from '../../../../../../extractFromState';
import { getSelectedLineItems, getSelectedOrderNumber } from '../../../../../../selectors/tools';
import { refundOrderItems } from '../../../../../../actions/tools/CommonAsyncOrderActions';
import DTSelectedItemTransactionView from '../../DTSelectedItemTransactionView';
import { useReasons } from '../../../../../../customHooks/decisionTree/useReasons';
import DTImageSelector from '../../../../Common/DTImageSelector/DTImageSelector';
import { withConfirmation } from '../../../../DTConfirmationView/withConfirmation';
import { BlankReasonContainer } from '../../../../Common/DTSelectReason/DTSelectReason.styles';
import { setShowConfirmationPage } from '../../../../../../actions/tools/OrdersSearchActions';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { setLoading } from '../../../../../../actions';
import { REASON_TYPES } from 'constants/decisionTree';

const DTRefundSelectedItemsNode = () => {
  const dispatch = useDispatch();
  const selectedLineItems = useSelector(getSelectedLineItems);
  const orderNumber = useSelector(getSelectedOrderNumber);
  const orderId = get(useSelector(getSelectedOrderFromOrdersSearch), 'orderId');
  const domain = get(useSelector(getSelectedOrderFromOrdersSearch), 'simplrParams.domain');
  const simplrAccountId = useSelector(getSimplrAccountIdOfSelectedTicket);
  const [selectedImages, setSelectedImages] = useState([]);

  const { selectedReason, reasons, ReasonContainerComponent } = useReasons({
    loadingComponentName: 'itemTransactionContainer',
    skipImages: false,
    type: REASON_TYPES.REFUND,
  });

  const handleRefundButtonClick = async () => {
    try {
      dispatch(setLoading(true, 'itemTransactionContainer'));
      await dispatch(
        refundOrderItems({
          items: selectedLineItems,
          reason: selectedReason,
          imageUrls: selectedImages,
          domain,
          simplrAccountId,
          orderId,
          orderNumber,
        })
      );
      dispatch(setShowConfirmationPage());
    } catch (error) {
      dispatch(addEdgeToDecisionTreePath('transaction_failed'));
    } finally {
      dispatch(setLoading(false, 'itemTransactionContainer'));
    }
  };

  const isReasonsRequired = !isEmpty(reasons);
  const isImageRequired = !get(selectedReason, 'isImageOptional', true);
  const isReasonValid = !!selectedReason || !isReasonsRequired;
  const isNextEnabled = isImageRequired ? isReasonValid && !isEmpty(selectedImages) : isReasonValid;

  return (
    <DTSelectedItemTransactionView
      nextButtonLabel="REFUND"
      showContainer={!!reasons}
      isNextEnabled={isNextEnabled}
      nextButtonClickHandler={handleRefundButtonClick}
    >
      {isReasonsRequired ? (
        <>
          <ReasonContainerComponent />
          {isImageRequired && <DTImageSelector selectedImages={selectedImages} onSelect={setSelectedImages} />}
        </>
      ) : (
        <BlankReasonContainer />
      )}
    </DTSelectedItemTransactionView>
  );
};

export default withConfirmation(DTRefundSelectedItemsNode);
